module.exports = __WEBPACK_EXTERNAL_MODULE_12__;


//////////////////
// WEBPACK FOOTER
// external {"root":["Rx","Observable"],"commonjs":"rxjs/observable/of","commonjs2":"rxjs/observable/of","amd":"rxjs/observable/of"}
// module id = 12
// module chunks = 0 1